export const CheckingAccountTypeList = [
    { type: 'billing.bankAccountTypes.checking', code: 'checking' },
    { type: 'billing.bankAccountTypes.savings', code: 'savings' }
];
